import React from 'react';
import { Badge } from 'components/common';
import * as MdIcons from 'react-icons/md';
import PropTypes from 'prop-types';

const COLOR_TO_VARIANT = {
  secondary: 'default',
  primary:   'primary',
  info:      'info',
  warning:   'negotiation',
  success:   'won',
  danger:    'lost',
};

// crm_sales_pipelines.id → badge variant. Only used when the pipeline row has no
// `color`, so it is a safety net rather than the primary mapping. Keep in sync
// with the ids in app/lib/constants.rb (CRM_SALES_PIPELINE_*).
const PIPELINE_VARIANT_FALLBACK = {
  1:  'new_pcv',      // PCV creation
  2:  'draft',        // Technical definition
  3:  'quotation',    // Concept design
  4:  'tendering',    // Proposal submission
  5:  'tendering',    // Proposal revision
  6:  'negotiation',  // Contract negotiation
  7:  'signed',       // Contract agreement
  8:  'won',          // Enter job
  9:  'execution',    // Finance security
  10: 'execution',    // Fabrication
  11: 'execution',    // Shipment
  12: 'completed',    // Completed
  13: 'lost',         // Lost
};

const ProjectStatusRenderer = ({ value, data = {} }) => {
  const pipeline = data?.sales_pipeline;

  const variant =
    COLOR_TO_VARIANT[pipeline?.color] ||
    PIPELINE_VARIANT_FALLBACK[pipeline?.id] ||
    Badge.getVariantFromStatus(value);

  const Icon = pipeline?.icon ? MdIcons[pipeline.icon] : null;

  return (
    <Badge variant={variant} size="sm">
      {Icon && <Icon size={12} />}
      {value ?? '—'}
    </Badge>
  );
};

ProjectStatusRenderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data:  PropTypes.shape({
    sales_pipeline: PropTypes.shape({
      id:    PropTypes.number,
      color: PropTypes.string,
      icon:  PropTypes.string,
    }),
  }),
};

export default ProjectStatusRenderer;
